export default __webpack_public_path__ + "static/media/1707.07ebd213.png";